<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: value =>
      ['scheduled', 'confirmed', 'completed', 'cancelled', 'no_show'].includes(
        value
      ),
  },
});

const { t } = useI18n();

const STATUS_CLASSES = {
  scheduled: 'bg-n-blue-2 text-n-blue-11',
  confirmed: 'bg-n-teal-3 text-n-teal-11',
  completed: 'bg-n-slate-3 text-n-slate-11',
  cancelled: 'bg-n-ruby-2 text-n-ruby-11',
  no_show: 'bg-n-amber-2 text-n-amber-11',
};

const STATUS_KEYS = {
  scheduled: 'APPOINTMENTS.STATUS.SCHEDULED',
  confirmed: 'APPOINTMENTS.STATUS.CONFIRMED',
  completed: 'APPOINTMENTS.STATUS.COMPLETED',
  cancelled: 'APPOINTMENTS.STATUS.CANCELLED',
  no_show: 'APPOINTMENTS.STATUS.NO_SHOW',
};

const badgeClasses = computed(
  () =>
    `inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${STATUS_CLASSES[props.status] || 'bg-n-slate-3 text-n-slate-11'}`
);

const label = computed(() => {
  const key = STATUS_KEYS[props.status];
  return key ? t(key) : props.status;
});
</script>

<template>
  <span :class="badgeClasses">
    {{ label }}
  </span>
</template>
